import * as SwitchPrimitive from "@radix-ui/react-switch";
import { cva, type VariantProps } from "class-variance-authority";

import { cn } from "../../../lib/utils";
import { ComponentProps } from "react";

const appSwitchVariants = cva(
  "peer data-[state=checked]:bg-innoveraZinc-900 data-[state=unchecked]:bg-innoveraZinc-100 focus-visible:border-ring focus-visible:ring-ring/50 inline-flex shrink-0 items-center rounded-full border border-transparent transition-all outline-hidden focus-visible:ring-[3px] disabled:cursor-not-allowed disabled:opacity-50",
  {
    variants: {
      size: {
        default: "h-6 w-10 p-[2px]",
        sm: "h-[18px] w-[30px] p-[1.5px]"
      }
    },
    defaultVariants: {
      size: "default"
    }
  }
);

const appSwitchThumbVariants = cva(
  "bg-white pointer-events-none block rounded-full ring-0 transition-transform data-[state=unchecked]:-translate-x-px",
  {
    variants: {
      size: {
        default: "size-5 data-[state=checked]:translate-x-[calc(100%-5px)]",
        sm: "size-[15px] data-[state=checked]:translate-x-[calc(100%-4px)]"
      }
    },
    defaultVariants: {
      size: "default"
    }
  }
);

export type TAppSwitchProps = ComponentProps<typeof SwitchPrimitive.Root> &
  VariantProps<typeof appSwitchVariants> & {
    thumbClassName?: string;
  };

export function AppSwitch({ className, thumbClassName, size, ...props }: TAppSwitchProps) {
  return (
    <SwitchPrimitive.Root
      data-slot="switch"
      className={cn(appSwitchVariants({ size }), className)}
      {...props}
    >
      <SwitchPrimitive.Thumb
        data-slot="switch-thumb"
        className={cn(appSwitchThumbVariants({ size }), thumbClassName)}
      />
    </SwitchPrimitive.Root>
  );
}
